class ReleasePreview {
    currentAvailable;
    revolvingFundDebt;
    releaseWithAutomaticInvoice;
    releaseWithInvoice;
    releaseWithoutInvoice;
    constructor(data) {
        this.currentAvailable = data.currentAvailable;
        this.revolvingFundDebt = data.revolvingFundDebt;
        this.releaseWithAutomaticInvoice = data.releaseWithAutomaticInvoice;
        this.releaseWithInvoice = data.releaseWithInvoice;
        this.releaseWithoutInvoice = data.releaseWithoutInvoice;
    }
}
export default ReleasePreview;
